import type { OfficialAssetServerMaterial } from '$/api/server.types';

/** 角色性别 */
export type RoleGenGender = 'male' | 'female' | 'unspecified';
/** 角色年龄段 */
export type RoleGenAgeStage = 'child' | 'teen' | 'adult' | 'elderly';
/** 创建角色参考素材类型。 */
export type RoleGenMaterialCategory = 'clothing' | 'accessory' | 'hairstyle';
/** 角色参考素材来源。 */
export type RoleGenMaterialSource = 'official' | 'upload' | 'history';
/** 角色创建模型参数值。 */
export type RoleGenModelParameterValue = string | number | boolean;

/** 官方参考素材选中时对应的题材、标签和搜索条件。 */
export interface RoleGenMaterialFilter {
  genreId: number;
  tags: Record<string, string[]>;
  keyword?: string;
}

/** 弹窗内表单值。 */
export interface RoleGenFormValues {
  /** 必填，≤ 20 */
  name: string;
  /** 非必填，参考图 URL */
  referenceImageUrl?: string;
  /** 非必填，参考图来源，仅用于创建角色埋点。 */
  referenceImageSource?: RoleGenMaterialSource;
  /** 非必填，角色描述 */
  prompt: string;
  gender: RoleGenGender;
  ageStage: RoleGenAgeStage;
  /** 必填 */
  clothingMaterialId: string;
  clothingMaterialName?: string;
  clothingMaterialCoverUrl?: string;
  clothingMaterialSource?: RoleGenMaterialSource;
  clothingOfficialMaterial?: OfficialAssetServerMaterial;
  clothingMaterialFilter?: RoleGenMaterialFilter;
  /** 空串 = 不使用 */
  accessoryMaterialId?: string;
  accessoryMaterialName?: string;
  accessoryMaterialCoverUrl?: string;
  accessoryMaterialSource?: RoleGenMaterialSource;
  accessoryOfficialMaterial?: OfficialAssetServerMaterial;
  accessoryMaterialFilter?: RoleGenMaterialFilter;
  /** 空串 = 模型默认发型 */
  hairstyleMaterialId?: string;
  hairstyleMaterialName?: string;
  hairstyleMaterialCoverUrl?: string;
  hairstyleMaterialSource?: RoleGenMaterialSource;
  hairstyleOfficialMaterial?: OfficialAssetServerMaterial;
  hairstyleMaterialFilter?: RoleGenMaterialFilter;
  /** 必填 */
  modelId: string;
  /** 角色生成工具 API 名称，来自 character 模型首个 tool。 */
  modelApiName?: string;
  /** 角色生成节点模型 id，来自 character 模型首个 tool。 */
  nodeModelId?: string;
  /** 当前模型配置参数，来自 character tool.parameters。 */
  modelParameters: Record<string, RoleGenModelParameterValue>;
}

/** 表单初始默认值。 */
export const INITIAL_ROLE_GEN_FORM_VALUES: RoleGenFormValues = {
  name: '',
  referenceImageUrl: undefined,
  prompt: '',
  gender: 'unspecified',
  ageStage: 'adult',
  clothingMaterialId: '',
  accessoryMaterialId: '',
  hairstyleMaterialId: '',
  modelId: '',
  modelParameters: {},
};
